<template>
  <div class="text-gray-600 text-sm mb-8 w-full">
    <nav class="flex flex-wrap justify-between py-1">
      <ol class="flex">
        <li v-for="(crumb, index) in breadcrumbs" :key="index">
          <a
            class="text-sm text-gray-700"
            :class="{ 'font-semibold cursor-pointer': crumb.link }"
            @click="routeTo(crumb)"
          >
            {{ crumb.name }}
          </a>
          <span v-if="index < breadcrumbs.length - 1" class="mx-2">/</span>
        </li>
      </ol>
      <div class="flex"></div>
    </nav>
  </div>
</template>

<script>
import AuthUser from "./mixins/AuthUser";

export default {
  name: "Navbar",
  mixins: [AuthUser],
  data() {
    return {
      isAuthenticated: false,
      displayName: null,
      breadcrumbs: []
    };
  },
  methods: {
    routeTo(crumb) {
      if (crumb.link) {
        this.$router.push({ name: crumb.link });
      }
    }
  },
  created() {
    this.breadcrumbs = this.$route.meta.breadcrumbs;
  },
  watch: {
    $route() {
      this.breadcrumbs = this.$route.meta.breadcrumbs;
    }
  }
};
</script>
